import { Component, inject, OnInit } from '@angular/core';
import { Platform } from '@ionic/angular';
import { DatadogService } from './shared/service/datadog/datadog.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {

  private _datadogService = inject(DatadogService);
  animated = true;

  constructor(private platform: Platform) {
    this.removeAnimationPageIOS();
  }

  ngOnInit(): void {
    this._datadogService.init();
  }

  removeAnimationPageIOS() {
    if (this.platform.is('ios')) {
      this.animated = false;
    }
  }
  
}
